import CountdownAuctionEnds from './countdownAuctionEnds'

export default CountdownAuctionEnds
